import axios from "axios";
import { useMsal } from "Auth/msal-context";

const WithAxios = ({ children }) => {
  const { msalExec } = useMsal();
  axios.interceptors.request.use(
    async (config) => {
      await msalExec(config.scope, (accessToken) => {
        config.headers.Authorization = `Bearer ${accessToken}`;
        config.headers.ContentType = "application/json";
      });
      return config;
    },
    (error) => Promise.reject(error)
  );
  return children;
};

export default WithAxios;
